'use client';

import { useQuery } from '@tanstack/react-query';

import { fetchMiniPdpProductBase } from '../api';
import { useMiniPdpDrawer } from './use-mini-pdp-drawer';

const ONE_HOUR = 60 * 60 * 1000;

export const MINI_PDP_PRODUCT_BASE_QUERY_KEY = 'mini-pdp-product-base';

export const useQueryMiniPdpBase = () => {
    const isOpen = useMiniPdpDrawer(state => state.isOpen);
    const productId = useMiniPdpDrawer(state => state.productId);

    const { data, isLoading, isPending, isFetching, isError, error } = useQuery({
        queryKey: [MINI_PDP_PRODUCT_BASE_QUERY_KEY, productId],
        queryFn: async () => {
            if (!productId) return null;

            const response = await fetchMiniPdpProductBase(productId);
            if (!response) throw new Error('Failed to fetch mini PDP product base');

            return response;
        },
        enabled: isOpen && Boolean(productId),
        staleTime: ONE_HOUR,
        retry: false,
    });

    return { data, isLoading, isPending, isFetching, isError, error };
};
